import Vue from 'vue'
import Vuex from 'vuex'
import Api from 'src/api'
import state from './init-state'
import * as M_ from './mutations'

const strict = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  strict,
  mutations: {
    // user navigation counter
    [M_.moves.INCREMENT] (state) {
      state.moves++
    },
    // vector global init
    [M_.vector.INITIALIZE] (state) {
      state.vector.initialized = true
    },
    // author mutations
    [M_.authors.ADD] (state, author) {
      Vue.set(state.authors, author.uid, author)
    },
    // events mutations
    [M_.events.SET] (state, events) {
      state.events = events
    },
    [M_.events.SET_FEATURED] (state, featuredEvent) {
      state.events.featured = featuredEvent
    },
    // content mutations
    [M_.content.SET] (state, { view, data }) {
      Vue.set(state.content, view, data)
    },
    [M_.content.READY] (state, view) {
      state.content.ready = true
    },
    // blog posts mutations
    [M_.posts.SET_OFFSET] (state, id) {
      state.posts.offset = id
    },
    [M_.posts.SET_TOTAL] (state, total) {
      state.posts.total = total
    },
    [M_.posts.CACHE] (state, post) {
      Vue.set(state.posts.cache, post.path, post)
    },
    [M_.posts.SET_OFFSET_FEATURED] (state, offsetFeatured) {
      state.posts.offsetFeatured = offsetFeatured
    }
  },

  actions: {
    onLoad({ commit }) {
      Api.connect().then(ref => {
        Promise.all([
          Api.dispatch.fetchOnLoad(['blog', 'home', 'calendar', 'ecosystem', 'meta']),
          Api.dispatch.fetchPostCount()
        ]).then(([results, total]) => {
          results.forEach(({ view, data }) => {
            commit('content/SET', { view, data })
          })

          commit('posts/SET_TOTAL', total)
          commit('content/READY')
        })
      })
    },

    fetchAuthors({ commit }) {
      Api.dispatch.fetchAuthors().then(results => {
        results.forEach(author => {
          commit('authors/ADD', author)
        })
      })
    }
  },

  getters: {
    findPost: state => path => state.posts.cache[path] || false,
    findEvent: state => path => state.events.cache[path] || false
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js